import { FictiveWebShop } from '@as-react/common-types';
export const getCountryByFictiveWebShop = (fictiveWebShop) => {
    switch (fictiveWebShop) {
        case FictiveWebShop.BEVER_NL:
        case FictiveWebShop.ASADVENTURE_NL:
            return 'NL';
        case FictiveWebShop.ASADVENTURE_FR:
            return 'FR';
        case FictiveWebShop.ASADVENTURE_LU:
            return 'LU';
        case FictiveWebShop.COTSWOLDOUTDOOR_COM:
        case FictiveWebShop.SNOWANDROCK_COM:
        case FictiveWebShop.CYCLESURGERY_COM:
        case FictiveWebShop.RUNNERSNEED_COM:
        case FictiveWebShop.ASADVENTURE_CO_UK:
            return 'GB';
        case FictiveWebShop.COTSWOLDOUTDOOR_IE:
            return 'IE';
        case FictiveWebShop.COTSWOLDOUTDOOR_US:
            return 'US';
        case FictiveWebShop.COTSWOLDOUTDOOR_COM_AU:
            return 'AU';
        default:
            return 'BE';
    }
};
